import React from 'react';
import TopStepAccountPage, { type AccountPageProps } from './TopStepAccountPage';

const TOPSTEP_100K_ACCOUNT_ID = 22511054;
const TOPSTEP_100K_ACCOUNT_MARKERS = ['100K', '100KTC', '573439-77282311', '77282311'];

const matchTopStep100KAccount: AccountPageProps['accountMatcher'] = (accounts) => {
  const exact = accounts.find((account) => account.accountId === TOPSTEP_100K_ACCOUNT_ID);
  if (exact) return exact;

  return accounts.find((account) => {
    const accountName = account.accountName.toUpperCase();
    return TOPSTEP_100K_ACCOUNT_MARKERS.some((marker) => accountName.includes(marker));
  });
};

const TopStep100KChallengePage: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep 100K Challenge"
    accountMatcher={matchTopStep100KAccount}
    challengeParams={{ target: 6000, hardMax: 3000, internalStop: 2550, dailyCap: 1200, accountSize: 100000 }}
    chipLabel="100K CHALLENGE"
    chipColor="#D4AF37"
  />
);

export default TopStep100KChallengePage;
